export const TKeyHomeMeidly = {
  HOME_MEIDLY_HERO_SUP_TITLE: "HOME_MEIDLY_HERO_SUP_TITLE",
  HOME_MEIDLY_HERO_TITLE: "HOME_MEIDLY_HERO_TITLE",
  HOME_MEIDLY_HERO_TEXT: "HOME_MEIDLY_HERO_TEXT",
  HOME_WAITLIST_CTA: "HOME_WAITLIST_CTA",
  HOME_WAITLIST_CTA_SHORT: "HOME_WAITLIST_CTA_SHORT",
  HOME_WAITLIST_HERO_NOTE: "HOME_WAITLIST_HERO_NOTE",
  HOME_WAITLIST_TEXT: "HOME_WAITLIST_TEXT",
  HOME_WAITLIST_CONSENT: "HOME_WAITLIST_CONSENT",
  HOME_WAITLIST_CONSENT_LINK: "HOME_WAITLIST_CONSENT_LINK",
  HOME_WAITLIST_FIRST_NAME: "HOME_WAITLIST_FIRST_NAME",
  HOME_WAITLIST_LAST_NAME: "HOME_WAITLIST_LAST_NAME",
  HOME_WAITLIST_COMPANY: "HOME_WAITLIST_COMPANY",
  HOME_WAITLIST_PHONE: "HOME_WAITLIST_PHONE",
  HOME_WAITLIST_TEAM_SIZE: "HOME_WAITLIST_TEAM_SIZE",
  HOME_WAITLIST_TEAM_SIZE_1: "HOME_WAITLIST_TEAM_SIZE_1",
  HOME_WAITLIST_TEAM_SIZE_2: "HOME_WAITLIST_TEAM_SIZE_2",
  HOME_WAITLIST_TEAM_SIZE_3: "HOME_WAITLIST_TEAM_SIZE_3",
  HOME_WAITLIST_DONE_TITLE: "HOME_WAITLIST_DONE_TITLE",
  HOME_WAITLIST_SUCCESS: "HOME_WAITLIST_SUCCESS",
  HOME_WAITLIST_DONE_CLOSE: "HOME_WAITLIST_DONE_CLOSE",
  HOME_WAITLIST_FINAL_TITLE: "HOME_WAITLIST_FINAL_TITLE",
  HOME_WAITLIST_FINAL_TEXT: "HOME_WAITLIST_FINAL_TEXT",
  HOME_WAITLIST_SUBMIT: "HOME_WAITLIST_SUBMIT",
  HOME_WAITLIST_ALREADY: "HOME_WAITLIST_ALREADY",
  HOME_WAITLIST_CAPTCHA_ERROR: "HOME_WAITLIST_CAPTCHA_ERROR",
  HOME_WAITLIST_ERROR: "HOME_WAITLIST_ERROR",
  HOME_MEIDLY_HERO_SECONDARY_CTA: "HOME_MEIDLY_HERO_SECONDARY_CTA",
  HOME_MEIDLY_HERO_PRICING: "HOME_MEIDLY_HERO_PRICING",
  HOME_MEIDLY_DEMO_PLAY: "HOME_MEIDLY_DEMO_PLAY",
  HOME_MEIDLY_FLOW_STEP_1: "HOME_MEIDLY_FLOW_STEP_1",
  HOME_MEIDLY_FLOW_STEP_2: "HOME_MEIDLY_FLOW_STEP_2",
  HOME_MEIDLY_FLOW_STEP_3: "HOME_MEIDLY_FLOW_STEP_3",
  HOME_MEIDLY_FLOW_STEP_1_TEXT: "HOME_MEIDLY_FLOW_STEP_1_TEXT",
  HOME_MEIDLY_FLOW_STEP_2_TEXT: "HOME_MEIDLY_FLOW_STEP_2_TEXT",
  HOME_MEIDLY_FLOW_STEP_3_TEXT: "HOME_MEIDLY_FLOW_STEP_3_TEXT",
  HOME_MEIDLY_FLOW_CALL_TITLE: "HOME_MEIDLY_FLOW_CALL_TITLE",
  HOME_MEIDLY_FLOW_CALL_REC: "HOME_MEIDLY_FLOW_CALL_REC",
  HOME_MEIDLY_FLOW_CAPTURED_BY: "HOME_MEIDLY_FLOW_CAPTURED_BY",
  HOME_MEIDLY_FLOW_MESSAGE_TITLE: "HOME_MEIDLY_FLOW_MESSAGE_TITLE",
  HOME_MEIDLY_FLOW_MESSAGE_STATUS: "HOME_MEIDLY_FLOW_MESSAGE_STATUS",
  HOME_MEIDLY_FLOW_MESSAGE_PLACEHOLDER: "HOME_MEIDLY_FLOW_MESSAGE_PLACEHOLDER",
  HOME_MEIDLY_FLOW_MESSAGE_IN: "HOME_MEIDLY_FLOW_MESSAGE_IN",
  HOME_MEIDLY_FLOW_MESSAGE_OUT: "HOME_MEIDLY_FLOW_MESSAGE_OUT",
  HOME_MEIDLY_FLOW_SOURCE_EMAIL: "HOME_MEIDLY_FLOW_SOURCE_EMAIL",
  HOME_MEIDLY_FLOW_SOURCE_LINKEDIN: "HOME_MEIDLY_FLOW_SOURCE_LINKEDIN",
  HOME_MEIDLY_FLOW_SOURCE_WHATSAPP: "HOME_MEIDLY_FLOW_SOURCE_WHATSAPP",
  HOME_MEIDLY_FLOW_SOURCE_MORE: "HOME_MEIDLY_FLOW_SOURCE_MORE",
  HOME_MEIDLY_FLOW_SOURCES_LABEL: "HOME_MEIDLY_FLOW_SOURCES_LABEL",
  HOME_MEIDLY_FLOW_SOURCE_MEET: "HOME_MEIDLY_FLOW_SOURCE_MEET",
  HOME_MEIDLY_FLOW_SOURCE_ZOOM: "HOME_MEIDLY_FLOW_SOURCE_ZOOM",
  HOME_MEIDLY_FLOW_SOURCE_TEAMS: "HOME_MEIDLY_FLOW_SOURCE_TEAMS",
  HOME_MEIDLY_FLOW_SOURCE_DRIVE: "HOME_MEIDLY_FLOW_SOURCE_DRIVE",
  HOME_MEIDLY_FLOW_RECORD_TITLE: "HOME_MEIDLY_FLOW_RECORD_TITLE",
  HOME_MEIDLY_FLOW_RECORD_SYNC: "HOME_MEIDLY_FLOW_RECORD_SYNC",
  HOME_MEIDLY_FLOW_RECORD_NOTE: "HOME_MEIDLY_FLOW_RECORD_NOTE",
  HOME_MEIDLY_FLOW_ANSWER_TITLE: "HOME_MEIDLY_FLOW_ANSWER_TITLE",
  HOME_MEIDLY_FLOW_ANSWER_COUNT: "HOME_MEIDLY_FLOW_ANSWER_COUNT",
  HOME_MEIDLY_FLOW_ANSWER_NOTE: "HOME_MEIDLY_FLOW_ANSWER_NOTE",
  HOME_MEIDLY_FLOW_MCP_TITLE: "HOME_MEIDLY_FLOW_MCP_TITLE",
  HOME_MEIDLY_FLOW_MCP_SYNC: "HOME_MEIDLY_FLOW_MCP_SYNC",
  HOME_MEIDLY_FLOW_MCP_NOTE: "HOME_MEIDLY_FLOW_MCP_NOTE",
  HOME_MEIDLY_HOW_SUP_TITLE: "HOME_MEIDLY_HOW_SUP_TITLE",
  HOME_MEIDLY_HOW_TITLE: "HOME_MEIDLY_HOW_TITLE",
  HOME_MEIDLY_HOW_CAPTURE_LABEL: "HOME_MEIDLY_HOW_CAPTURE_LABEL",
  HOME_MEIDLY_HOW_CAPTURE_TITLE: "HOME_MEIDLY_HOW_CAPTURE_TITLE",
  HOME_MEIDLY_HOW_CAPTURE_BULLET_1: "HOME_MEIDLY_HOW_CAPTURE_BULLET_1",
  HOME_MEIDLY_HOW_CAPTURE_BULLET_2: "HOME_MEIDLY_HOW_CAPTURE_BULLET_2",
  HOME_MEIDLY_HOW_CAPTURE_BULLET_3: "HOME_MEIDLY_HOW_CAPTURE_BULLET_3",
  HOME_MEIDLY_HOW_DATE_TODAY: "HOME_MEIDLY_HOW_DATE_TODAY",
  HOME_MEIDLY_HOW_DATE_YESTERDAY: "HOME_MEIDLY_HOW_DATE_YESTERDAY",
  HOME_MEIDLY_HOW_DATE_DAYS_AGO: "HOME_MEIDLY_HOW_DATE_DAYS_AGO",
  HOME_MEIDLY_HOW_ANALYSING: "HOME_MEIDLY_HOW_ANALYSING",
  HOME_MEIDLY_HOW_EX_BUDGET: "HOME_MEIDLY_HOW_EX_BUDGET",
  HOME_MEIDLY_HOW_EX_DEMO: "HOME_MEIDLY_HOW_EX_DEMO",
  HOME_MEIDLY_HOW_EX_QUOTE_FOLLOW_UP: "HOME_MEIDLY_HOW_EX_QUOTE_FOLLOW_UP",
  HOME_MEIDLY_HOW_EX_FIRST_CONTACT: "HOME_MEIDLY_HOW_EX_FIRST_CONTACT",
  HOME_MEIDLY_HOW_EX_COMMITTEE: "HOME_MEIDLY_HOW_EX_COMMITTEE",
  HOME_MEIDLY_HOW_MOCK_JOB_TITLE: "HOME_MEIDLY_HOW_MOCK_JOB_TITLE",
  HOME_MEIDLY_HOW_COMMITMENT_1: "HOME_MEIDLY_HOW_COMMITMENT_1",
  HOME_MEIDLY_HOW_COMMITMENT_1_DUE: "HOME_MEIDLY_HOW_COMMITMENT_1_DUE",
  HOME_MEIDLY_HOW_FILE_LABEL: "HOME_MEIDLY_HOW_FILE_LABEL",
  HOME_MEIDLY_HOW_FILE_TITLE: "HOME_MEIDLY_HOW_FILE_TITLE",
  HOME_MEIDLY_HOW_FILE_BULLET_1: "HOME_MEIDLY_HOW_FILE_BULLET_1",
  HOME_MEIDLY_HOW_FILE_BULLET_2: "HOME_MEIDLY_HOW_FILE_BULLET_2",
  HOME_MEIDLY_HOW_FILE_BULLET_3: "HOME_MEIDLY_HOW_FILE_BULLET_3",
  HOME_MEIDLY_HOW_FILE_SUMMARY: "HOME_MEIDLY_HOW_FILE_SUMMARY",
  HOME_MEIDLY_HOW_PASSAGE_1: "HOME_MEIDLY_HOW_PASSAGE_1",
  HOME_MEIDLY_HOW_FILE_TALK: "HOME_MEIDLY_HOW_FILE_TALK",
  HOME_MEIDLY_HOW_FILE_INTERRUPTIONS: "HOME_MEIDLY_HOW_FILE_INTERRUPTIONS",
  HOME_MEIDLY_HOW_DEAL_1: "HOME_MEIDLY_HOW_DEAL_1",
  HOME_MEIDLY_HOW_PERSONA_LABEL: "HOME_MEIDLY_HOW_PERSONA_LABEL",
  HOME_MEIDLY_HOW_PERSONA_TITLE: "HOME_MEIDLY_HOW_PERSONA_TITLE",
  HOME_MEIDLY_HOW_PERSONA_BULLET_1: "HOME_MEIDLY_HOW_PERSONA_BULLET_1",
  HOME_MEIDLY_HOW_PERSONA_BULLET_2: "HOME_MEIDLY_HOW_PERSONA_BULLET_2",
  HOME_MEIDLY_HOW_PERSONA_BULLET_3: "HOME_MEIDLY_HOW_PERSONA_BULLET_3",
  HOME_MEIDLY_HOW_PERSONA_NAME: "HOME_MEIDLY_HOW_PERSONA_NAME",
  HOME_MEIDLY_HOW_PERSONA_CUSTOMERS: "HOME_MEIDLY_HOW_PERSONA_CUSTOMERS",
  HOME_MEIDLY_HOW_PERSONA_WIN_RATE: "HOME_MEIDLY_HOW_PERSONA_WIN_RATE",
  HOME_MEIDLY_HOW_PERSONA_REASON_1: "HOME_MEIDLY_HOW_PERSONA_REASON_1",
  HOME_MEIDLY_HOW_PERSONA_PAIN_1: "HOME_MEIDLY_HOW_PERSONA_PAIN_1",
  HOME_MEIDLY_HOW_PERSONA_CRITERION_3_LABEL: "HOME_MEIDLY_HOW_PERSONA_CRITERION_3_LABEL",
  HOME_MEIDLY_HOW_PERSONA_CRITERION_3: "HOME_MEIDLY_HOW_PERSONA_CRITERION_3",
  HOME_MEIDLY_HOW_PERSONA_BRAKE_1: "HOME_MEIDLY_HOW_PERSONA_BRAKE_1",
  HOME_MEIDLY_HOW_PERSONA_QUERY_SEARCH: "HOME_MEIDLY_HOW_PERSONA_QUERY_SEARCH",
  HOME_MEIDLY_HOW_PERSONA_QUERY_QUALIFY: "HOME_MEIDLY_HOW_PERSONA_QUERY_QUALIFY",
  HOME_MEIDLY_HOW_PERSONA_CRITERION_7_LABEL: "HOME_MEIDLY_HOW_PERSONA_CRITERION_7_LABEL",
  HOME_MEIDLY_HOW_PERSONA_CRITERION_7: "HOME_MEIDLY_HOW_PERSONA_CRITERION_7",
  HOME_MEIDLY_HOW_PERSONA_MORE: "HOME_MEIDLY_HOW_PERSONA_MORE",
  HOME_MEIDLY_HOW_PERSONA_SHARE: "HOME_MEIDLY_HOW_PERSONA_SHARE",
  HOME_MEIDLY_HOW_PERSONA_CRITERION_1_LABEL: "HOME_MEIDLY_HOW_PERSONA_CRITERION_1_LABEL",
  HOME_MEIDLY_HOW_PERSONA_CRITERION_2_LABEL: "HOME_MEIDLY_HOW_PERSONA_CRITERION_2_LABEL",
  HOME_MEIDLY_HOW_PERSONA_CRITERION_4_LABEL: "HOME_MEIDLY_HOW_PERSONA_CRITERION_4_LABEL",
  HOME_MEIDLY_HOW_PERSONA_CRITERION_1: "HOME_MEIDLY_HOW_PERSONA_CRITERION_1",
  HOME_MEIDLY_HOW_PERSONA_CRITERION_2: "HOME_MEIDLY_HOW_PERSONA_CRITERION_2",
  HOME_MEIDLY_HOW_PERSONA_CRITERION_4: "HOME_MEIDLY_HOW_PERSONA_CRITERION_4",
  HOME_MEIDLY_HOW_ASSISTANT_LABEL: "HOME_MEIDLY_HOW_ASSISTANT_LABEL",
  HOME_MEIDLY_HOW_ASSISTANT_TITLE: "HOME_MEIDLY_HOW_ASSISTANT_TITLE",
  HOME_MEIDLY_HOW_ASSISTANT_QUESTION: "HOME_MEIDLY_HOW_ASSISTANT_QUESTION",
  HOME_MEIDLY_HOW_ASSISTANT_ANSWER_1: "HOME_MEIDLY_HOW_ASSISTANT_ANSWER_1",
  HOME_MEIDLY_HOW_ASSISTANT_ANSWER_2: "HOME_MEIDLY_HOW_ASSISTANT_ANSWER_2",
  HOME_MEIDLY_HOW_ASSISTANT_CHART_TITLE: "HOME_MEIDLY_HOW_ASSISTANT_CHART_TITLE",
  HOME_MEIDLY_HOW_ASSISTANT_CHART_CAPTION: "HOME_MEIDLY_HOW_ASSISTANT_CHART_CAPTION",
  HOME_MEIDLY_HOW_ASSISTANT_BAR_1: "HOME_MEIDLY_HOW_ASSISTANT_BAR_1",
  HOME_MEIDLY_HOW_ASSISTANT_BAR_2: "HOME_MEIDLY_HOW_ASSISTANT_BAR_2",
  HOME_MEIDLY_HOW_ASSISTANT_BAR_3: "HOME_MEIDLY_HOW_ASSISTANT_BAR_3",
  HOME_MEIDLY_HOW_ASSISTANT_BULLET_1: "HOME_MEIDLY_HOW_ASSISTANT_BULLET_1",
  HOME_MEIDLY_HOW_ASSISTANT_BULLET_2: "HOME_MEIDLY_HOW_ASSISTANT_BULLET_2",
  HOME_MEIDLY_HOW_ASSISTANT_BULLET_3: "HOME_MEIDLY_HOW_ASSISTANT_BULLET_3",
  HOME_MEIDLY_TOOLS_SUP_TITLE: "HOME_MEIDLY_TOOLS_SUP_TITLE",
  HOME_MEIDLY_TOOLS_TITLE: "HOME_MEIDLY_TOOLS_TITLE",
  HOME_MEIDLY_TOOLS_INTRO_TEXT: "HOME_MEIDLY_TOOLS_INTRO_TEXT",
  HOME_MEIDLY_TOOLS_CHECK_1: "HOME_MEIDLY_TOOLS_CHECK_1",
  HOME_MEIDLY_TOOLS_CHECK_1_TEXT: "HOME_MEIDLY_TOOLS_CHECK_1_TEXT",
  HOME_MEIDLY_TOOLS_CHECK_2: "HOME_MEIDLY_TOOLS_CHECK_2",
  HOME_MEIDLY_TOOLS_CHECK_2_TEXT: "HOME_MEIDLY_TOOLS_CHECK_2_TEXT",
  HOME_MEIDLY_TOOLS_CHECK_3: "HOME_MEIDLY_TOOLS_CHECK_3",
  HOME_MEIDLY_TOOLS_CHECK_3_TEXT: "HOME_MEIDLY_TOOLS_CHECK_3_TEXT",
  HOME_MEIDLY_CTA_TITLE: "HOME_MEIDLY_CTA_TITLE",
  HOME_MEIDLY_CTA_TEXT: "HOME_MEIDLY_CTA_TEXT",
  HOME_MEIDLY_TOOLS_FLAGSHIP: "HOME_MEIDLY_TOOLS_FLAGSHIP",
  HOME_MEIDLY_TOOLS_UPCOMING: "HOME_MEIDLY_TOOLS_UPCOMING",
  HOME_MEIDLY_TOOLS_BTN_ACCESS: "HOME_MEIDLY_TOOLS_BTN_ACCESS",
  HOME_MEIDLY_TOOLS_BTN_NOTIFY: "HOME_MEIDLY_TOOLS_BTN_NOTIFY",
  HOME_MEIDLY_TOOLS_1_DESC: "HOME_MEIDLY_TOOLS_1_DESC",
  HOME_MEIDLY_TOOLS_2_DESC: "HOME_MEIDLY_TOOLS_2_DESC",
  HOME_MEIDLY_TOOLS_3_DESC: "HOME_MEIDLY_TOOLS_3_DESC",
  HOME_MEIDLY_TOOLS_4_DESC: "HOME_MEIDLY_TOOLS_4_DESC",
  HOME_MEIDLY_TOOLS_5_DESC: "HOME_MEIDLY_TOOLS_5_DESC",
  HOME_MEIDLY_TOOLS_6_DESC: "HOME_MEIDLY_TOOLS_6_DESC",
  HOME_MEIDLY_TOOLS_7_DESC: "HOME_MEIDLY_TOOLS_7_DESC",
  HOME_MEIDLY_TOOLS_8_DESC: "HOME_MEIDLY_TOOLS_8_DESC",
  HOME_MEIDLY_PRICING_SUP_TITLE: "HOME_MEIDLY_PRICING_SUP_TITLE",
  HOME_MEIDLY_PRICING_FOUNDER_BADGE: "HOME_MEIDLY_PRICING_FOUNDER_BADGE",
  HOME_MEIDLY_PRICING_PUBLIC_PRICE: "HOME_MEIDLY_PRICING_PUBLIC_PRICE",
  HOME_MEIDLY_PRICING_TITLE: "HOME_MEIDLY_PRICING_TITLE",
  HOME_MEIDLY_PRICING_PERIOD_MONTHLY: "HOME_MEIDLY_PRICING_PERIOD_MONTHLY",
  HOME_MEIDLY_PRICING_PERIOD_ANNUAL: "HOME_MEIDLY_PRICING_PERIOD_ANNUAL",
  HOME_MEIDLY_PRICING_PERIOD_SAVE: "HOME_MEIDLY_PRICING_PERIOD_SAVE",
  HOME_MEIDLY_PRICING_PER_MONTH: "HOME_MEIDLY_PRICING_PER_MONTH",
  HOME_MEIDLY_PRICING_VAT: "HOME_MEIDLY_PRICING_VAT",
  HOME_MEIDLY_PRICING_BILLED_MONTHLY: "HOME_MEIDLY_PRICING_BILLED_MONTHLY",
  HOME_MEIDLY_PRICING_BILLED_ANNUALLY: "HOME_MEIDLY_PRICING_BILLED_ANNUALLY",
  HOME_MEIDLY_PRICING_INCLUDED: "HOME_MEIDLY_PRICING_INCLUDED",
  HOME_MEIDLY_PRICING_PRO_NAME: "HOME_MEIDLY_PRICING_PRO_NAME",
  HOME_MEIDLY_PRICING_PRO_TAGLINE: "HOME_MEIDLY_PRICING_PRO_TAGLINE",
  HOME_MEIDLY_PRICING_VOLUME_LABEL: "HOME_MEIDLY_PRICING_VOLUME_LABEL",
  HOME_MEIDLY_PRICING_PRO_FEATURE_TRIAL: "HOME_MEIDLY_PRICING_PRO_FEATURE_TRIAL",
  HOME_MEIDLY_PRICING_PRO_FEATURE_CHARACTERS: "HOME_MEIDLY_PRICING_PRO_FEATURE_CHARACTERS",
  HOME_MEIDLY_PRICING_PRO_FEATURE_ROLLOVER: "HOME_MEIDLY_PRICING_PRO_FEATURE_ROLLOVER",
  HOME_MEIDLY_PRICING_PRO_FEATURE_QUESTION: "HOME_MEIDLY_PRICING_PRO_FEATURE_QUESTION",
  HOME_MEIDLY_PRICING_PRO_FEATURE_IMPORTS: "HOME_MEIDLY_PRICING_PRO_FEATURE_IMPORTS",
  HOME_MEIDLY_PRICING_PRO_FEATURE_RECORDING: "HOME_MEIDLY_PRICING_PRO_FEATURE_RECORDING",
  HOME_MEIDLY_PRICING_PRO_FEATURE_PROSPECTS: "HOME_MEIDLY_PRICING_PRO_FEATURE_PROSPECTS",
  HOME_MEIDLY_PRICING_PRO_FEATURE_CUSTOMERS: "HOME_MEIDLY_PRICING_PRO_FEATURE_CUSTOMERS",
  HOME_MEIDLY_PRICING_PRO_FEATURE_INTEGRATIONS: "HOME_MEIDLY_PRICING_PRO_FEATURE_INTEGRATIONS",
  HOME_MEIDLY_PRICING_PRO_FEATURE_SUPPORT: "HOME_MEIDLY_PRICING_PRO_FEATURE_SUPPORT",
  HOME_MEIDLY_PRICING_CUSTOM_NAME: "HOME_MEIDLY_PRICING_CUSTOM_NAME",
  HOME_MEIDLY_PRICING_CUSTOM_PRICE: "HOME_MEIDLY_PRICING_CUSTOM_PRICE",
  HOME_MEIDLY_PRICING_CUSTOM_BILLING: "HOME_MEIDLY_PRICING_CUSTOM_BILLING",
  HOME_MEIDLY_PRICING_CUSTOM_TAGLINE: "HOME_MEIDLY_PRICING_CUSTOM_TAGLINE",
  HOME_MEIDLY_PRICING_CUSTOM_FEATURE_EVERYTHING: "HOME_MEIDLY_PRICING_CUSTOM_FEATURE_EVERYTHING",
  HOME_MEIDLY_PRICING_CUSTOM_FEATURE_VOLUME: "HOME_MEIDLY_PRICING_CUSTOM_FEATURE_VOLUME",
  HOME_MEIDLY_PRICING_CUSTOM_FEATURE_ONBOARDING: "HOME_MEIDLY_PRICING_CUSTOM_FEATURE_ONBOARDING",
  HOME_MEIDLY_PRICING_CUSTOM_FEATURE_SUPPORT: "HOME_MEIDLY_PRICING_CUSTOM_FEATURE_SUPPORT",
} as const;
